// extracted by mini-css-extract-plugin
export default {"messagePage":"MessagePage_messagePage__6+VKo","pageContainer":"MessagePage_pageContainer__XD+uQ","form":"MessagePage_form__e6NK7"};